import React, {useState, useEffect} from 'react'
import Header from '@/components/Header'
import Tabs from '@/components/Tabs'
import Empty from '@/components/Empty'
import {Content, Card, InvitationContainer, Center} from '@/styles/acitvityInfo'
import {getInvited} from '@/api/user-new'
import ListView from '@/components/ListView'
import moment from 'moment'
let pageIndex = 1;

// function genData() {
//   const dataArr = [];
//   for (let i = 0; i < 20; i++) {
//     dataArr.push({title: '1882288695'+ i, invitedTime: '2021-10-15'})
//   }
//   return dataArr;
// }
function splitArr(data, num=0) {
    let arr = []
    if(num === 0) {
      arr = data
    } else {
      arr =  data.slice(0,  num * 10) 
    }
    return arr
}
const MyInvitation = ({props}) => {
  const [tabs, setTabs] = useState([
    {title: '已激活用户（0）',key: '1'},
    {title: '未激活用户（0）',key: '2'}
  ])
  const [current, setcurrent] = useState('1')
  const [endText, setEndText] = useState('')
  const [refreshing, setrefreshing] = useState(false)
  const [isLoading, setisLoading] = useState(false)
  const [total, settotal] = useState(0)
  const [total1, settotal1] = useState(0)
  const [activatedList, setactivatedList] = useState([])
  const [cards, setcards] = useState([])
  const [uncards, setuncards] = useState([])
  const [notActivatedList, setnotActivatedList] = useState([])
  const getdata = () => {
    let id = props.match.params.id
    let data = {}
    let params = {}
    if (id) {
      params = {
        activityId: id
      }
      if(id === 20|| id === '20'){
        data.activityIds=[22]
      }
    }
    
    getInvited(params,data).then(res=>{
      setcards(res.activatedList&& res.activatedList.length>0 ? splitArr(res.activatedList, 1):  [])
      setuncards(res.notActivatedList&& res.notActivatedList.length>0 ? splitArr(res.notActivatedList, 1): [])
      setactivatedList(res.activatedList|| [])
      setnotActivatedList(res.notActivatedList|| [])
      settotal((res.activatedList && res.activatedList.length)|| 0)
      settotal1((res.notActivatedList && res.notActivatedList.length)|| 0)
      setTabs([
        {title: `${id ? '已邀请' : '已激活用户'}（${res.activatedList ? res.activatedList.length:  0})`, key: '1'},
        {title: `${id ? '邀请中' : '未激活用户'}（${res.notActivatedList ? res.notActivatedList.length:  0})`, key: '2'}
      ])
      setrefreshing(false)
    })
  }
  const initData = () => {
    let id = props.match.params.id
    if (id) {
      setTabs([
        {title: `已邀请`, key: '1'},
        {title: `邀请中`, key: '2'}
      ])
    }
  }
  useEffect(() => {
    initData()
    getdata()
  }, [])
  const onTabClick = tab =>{
    pageIndex = 0
    setcurrent(tab.key)
    setrefreshing(false)
    setisLoading(false)
  }
  const onRefresh = () => {
    setrefreshing(true)
    setisLoading(false)
    pageIndex = 1
    getdata()
  }
  const onEndReached = () =>{
    if (pageIndex * 10 < total && total > 10) {
      setisLoading(true)
      setTimeout(() => {
        setisLoading(false)
        setcards(splitArr(activatedList, ++pageIndex))
      }, 1000)
    } else {
        setEndText('暂无更多数据')
        setisLoading(false)
    }
  }
  const onEndReached1 = () =>{
    if (pageIndex * 10 < total1 && total1 > 10) {
      setisLoading(true)
      setTimeout(() => {
        setisLoading(false)
        setuncards(splitArr(notActivatedList, ++pageIndex))
      }, 1000)
    } else {
        setEndText('暂无更多数据')
        setisLoading(false)
    }
  }
  const CardList = (rowData) => <Card key={rowData.key}><div className={'title'}>用户{rowData.userPhone}通过你的链接注册{current==='1'?'并激活':'未激活'}</div><div className={'date'}>{moment(rowData.invitedTime).format('YYYY-MM-DD')}</div></Card>
  return (
    <InvitationContainer>
      <Header title={'我的邀请'}></Header>
      <Content top={'20px'}>
         <Tabs width ={ '100%'} onTabClick={onTabClick} tabs={tabs} Fixed></Tabs>
         {current=== '1'? ( cards.length> 0? <ListView  OnRefresh={onRefresh}  OnEndReached={onEndReached}  endText={endText} refreshing={refreshing} content={cards} isLoading={isLoading} renderRow={CardList}></ListView>:<Center> <Empty /></Center>) : null} 
         {current=== '2' ? ( uncards.length> 0? <ListView  OnRefresh={onRefresh}   OnEndReached={onEndReached1}  endText={endText} refreshing={refreshing} content={uncards} isLoading={isLoading} renderRow={CardList}></ListView>:<Center> <Empty /></Center>): null} 
      </Content>
    </InvitationContainer>
  )
}

export default MyInvitation


// WEBPACK FOOTER //
// ./src/views/user-new/my-invitation/index.js